import { TranslateFunc } from 'src/components/translate';

export type ColorVal = {
  hex: string | null;
  order: number;
  translationKey: string | null;
  nonNormalizedColor?: string;
};

export const getColor = (color: string | null): ColorVal => {
  switch (color) {
    case 'Black':
      return {
        hex: '#000000',
        order: 1,
        translationKey: 'colors.black',
      };
    case 'White':
      return {
        hex: '#FFFFFF',
        order: 2,
        translationKey: 'colors.white',
      };
    case 'Grey':
      return {
        hex: '#808080',
        order: 3,
        translationKey: 'colors.grey',
      };
    case 'Blue':
      return {
        hex: '#1E90FF',
        order: 4,
        translationKey: 'colors.blue',
      };
    case 'Red':
      return {
        hex: '#FF002B',
        order: 5,
        translationKey: 'colors.red',
      };
    case 'Green':
      return {
        hex: '#00D471',
        order: 6,
        translationKey: 'colors.green',
      };
    case 'Beige':
      return {
        hex: '#F5F5DC',
        order: 7,
        translationKey: 'colors.beige',
      };
    case 'Orange':
      return {
        hex: '#FFA500',
        order: 8,
        translationKey: 'colors.orange',
      };
    case 'Pink':
      return {
        hex: '#FFA6B6',
        order: 9,
        translationKey: 'colors.pink',
      };
    case 'Brown':
      return {
        hex: '#915B25',
        order: 10,
        translationKey: 'colors.brown',
      };
    case 'Yellow':
      return {
        hex: '#FFEA00',
        order: 11,
        translationKey: 'colors.yellow',
      };
    case 'Silver':
      return {
        hex: '#C0C0C0',
        order: 12,
        translationKey: 'colors.silver',
      };
    case 'Purple':
      return {
        hex: '#800080',
        order: 13,
        translationKey: 'colors.purple',
      };
    case 'Turquoise':
      return {
        hex: '#40E0D0',
        order: 14,
        translationKey: 'colors.turquoise',
      };
    case 'Khaki':
      return {
        hex: '#8A865D',
        order: 15,
        translationKey: 'colors.khaki',
      };
    case 'Gold':
      return {
        hex: '#D4AF37',
        order: 16,
        translationKey: 'colors.gold',
      };

    default:
      // In case we get non-normalized values from backend
      return {
        hex: null,
        order: 100,
        translationKey: null,
        nonNormalizedColor: color ?? '',
      };
  }
};

export const getColorTranslation = (
  t: TranslateFunc,
  color: string | null
): string => {
  const colorVal = getColor(color);
  if (colorVal.translationKey) {
    return t(
      'common',
      // @ts-ignore
      colorVal.translationKey
    ) as string;
  }
  if (colorVal.nonNormalizedColor) {
    return colorVal.nonNormalizedColor;
  }
  return '';
};
